<template>
  <div class="tx-dealersearch module-search-results">
    <div class="search-results__representative">
      <div v-for="person in representative" :key="person.uid" class="representative__item">
        <div class="result__headline">
          <div class="headline__title">
            <span class="heading epsilon">{{ person.name }}</span>
            <div class="result__description">
              <span>{{ $t('dealersearch.representative.description') }}
                <span v-for="country in Object.values(person.countries).filter(country => country.isoCode === searchedCountry)" :key="country.uid">
                  {{ country.name }}
                </span>
              </span>
            </div>
          </div>
          <div class="headline__image">
            <img :src="person.image.split('|')[0]" :alt="person.name" :title="person.name">
          </div>
        </div>
        <div class="result__actions">
          <div class="actions__wrapper">
            <div class="action__phone" v-if="person.phone">
              <a :href="`tel:${person.phone}`" class="btn -btn-white icon-phone-before" @click="handleTelLink"><span v-if="!showTel">{{ $t('dealersearch.result.phone') }}</span><span v-else>{{ person.phone }}</span></a>
            </div>
            <div class="action__email" v-if="person.email">
              <a :href="`mailto:${person.email}`" class="btn -btn-white icon-email-before"><span>{{ $t('dealersearch.result.email') }}</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search-results__results" v-if="!resultsIsEmpty()" :class="{'-gradient': results.length < numberOfTotalItems}">
      <SearchResult
        v-for="(result, index) in results"
        :result="result"
        :key="result.uid"
        :clicked="isClicked(index)"
        @mouseenter="$emit('mouseenterResult', index)"
        @mouseleave="$emit('mouseleaveResult')"/>
    </div>
    <div class="search-results__load-more module-load-more" v-if="!resultsIsEmpty()">
      <div class="load-more__button" v-if="currentPage < numberOfPages">
        <div class="btn -btn-alpha" @click="loadMore">
          <span>{{ $t('dealersearch.pagination.button') }}</span>
        </div>
      </div>
      <div class="load-more__progress" v-if="initialized">
        <div class="progress__info">
          <span class="meta" v-html="$t('dealersearch.pagination.info', { current: results.length, total: numberOfTotalItems })"></span>
        </div>
        <div class="progress__bar"><span :style="{ width: (results.length / numberOfTotalItems * 100) + '%' }"></span></div>
      </div>
    </div>
    <div class="search-results__error" v-if="loaded && resultsIsEmpty ()">
      <span>{{ $t('dealersearch.filter.error') }}</span>
    </div>
  </div>
</template>

<script>
import SearchResult from '@/components/SearchResult'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SearchResults',
  inject: ['phone'],
  data () {
    return {
      showTel: false
    }
  },
  components: {
    SearchResult
  },
  props: {
    clickedPoiIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      results: state => state.dealer.dealers,
      representative: state => state.representative.representatives,
      currentPage: state => state.dealer.currentPage,
      itemsPerPage: state => state.dealer.itemsPerPage,
      numberOfPages: state => state.dealer.numberOfPages,
      numberOfTotalItems: state => state.dealer.numberOfTotalDealers,
      loaded: state => state.dealer.loaded,
      searchedCountry: state => state.country
    })
  },
  methods: {
    ...mapActions([
      'loadMore'
    ]),
    resultsIsEmpty () {
      return !(this.results.length > 0)
    },
    isClicked (index) {
      if (this.clickedPoiIndex === index) {
        return true
      }
      return false
    },
    handleTelLink (event) {
      if (!this.phone) {
        event.preventDefault()
        this.showTel = !this.showTel
      }
    }
  }
}
</script>
